const code = [
  {
    name: 'Vietnam(84)',
    value: '84',
    code: 'VN'
  },
  {
    name: 'Korea(850)',
    value: '850',
    code: 'KP'
  },
  {
    name: 'Japan(81)',
    value: '81',
    code: 'JP'
  },
  {
    name: 'Malaysia(60)',
    value: '60',
    code: 'MY'
  },
  {
    name: 'Thailand(66)',
    value: '66',
    code: 'TH'
  },
  {
    name: 'Singapore(65)',
    value: '65',
    code: 'SG'
  },
  {
    name: 'Taiwan(886)',
    value: '886',
    code: 'TW'
  },
  {
    name: 'Hong Kong(852)',
    value: '852',
    code: 'HK'
  },
  {
    name: 'France(33)',
    value: '33',
    code: 'FR'
  },
  {
    name: 'Afghanistan(93)',
    value: '93',
    code: 'AF'
  },
  {
    name: 'Aland Islands(358)',
    value: '358',
    code: 'AX'
  },
  {
    name: 'Albania(355)',
    value: '355',
    code: 'AL'
  },
  {
    name: 'Algeria(213)',
    value: '213',
    code: 'DZ'
  },
  {
    name: 'AmericanSamoa(1684)',
    value: '1684',
    code: 'AS'
  },
  {
    name: 'Andorra(376)',
    value: '376',
    code: 'AD'
  },
  {
    name: 'Angola(244)',
    value: '244',
    code: 'AO'
  },
  {
    name: 'Anguilla(1264)',
    value: '1264',
    code: 'AI'
  },
  {
    name: 'Antarctica(672)',
    value: '672',
    code: 'AQ'
  },
  {
    name: 'Antigua and Barbuda(1268)',
    value: '1268',
    code: 'AG'
  },
  {
    name: 'Argentina(54)',
    value: '54',
    code: 'AR'
  },
  {
    name: 'Armenia(374)',
    value: '374',
    code: 'AM'
  },
  {
    name: 'Aruba(297)',
    value: '297',
    code: 'AW'
  },
  {
    name: 'Australia(61)',
    value: '61',
    code: 'AU'
  },
  {
    name: 'Austria(43)',
    value: '43',
    code: 'AT'
  },
  {
    name: 'Azerbaijan(994)',
    value: '994',
    code: 'AZ'
  },
  {
    name: 'Bahamas(1242)',
    value: '1242',
    code: 'BS'
  },
  {
    name: 'Bahrain(973)',
    value: '973',
    code: 'BH'
  },
  {
    name: 'Bangladesh(880)',
    value: '880',
    code: 'BD'
  },
  {
    name: 'Barbados(1246)',
    value: '1246',
    code: 'BB'
  },
  {
    name: 'Belarus(375)',
    value: '375',
    code: 'BY'
  },
  {
    name: 'Belgium(32)',
    value: '32',
    code: 'BE'
  },
  {
    name: 'Belize(501)',
    value: '501',
    code: 'BZ'
  },
  {
    name: 'Benin(229)',
    value: '229',
    code: 'BJ'
  },
  {
    name: 'Bermuda(1441)',
    value: '1441',
    code: 'BM'
  },
  {
    name: 'Bhutan(975)',
    value: '975',
    code: 'BT'
  },
  {
    name: 'Bolivia, Plurinational State of(591)',
    value: '591',
    code: 'BO'
  },
  {
    name: 'Bosnia and Herzegovina(387)',
    value: '387',
    code: 'BA'
  },
  {
    name: 'Botswana(267)',
    value: '267',
    code: 'BW'
  },
  {
    name: 'Brazil(55)',
    value: '55',
    code: 'BR'
  },
  {
    name: 'British Indian Ocean Territory(246)',
    value: '246',
    code: 'IO'
  },
  {
    name: 'Brunei Darussalam(673)',
    value: '673',
    code: 'BN'
  },
  {
    name: 'Bulgaria(359)',
    value: '359',
    code: 'BG'
  },
  {
    name: 'Burkina Faso(226)',
    value: '226',
    code: 'BF'
  },
  {
    name: 'Burundi(257)',
    value: '257',
    code: 'BI'
  },
  {
    name: 'Cambodia(855)',
    value: '855',
    code: 'KH'
  },
  {
    name: 'Cameroon(237)',
    value: '237',
    code: 'CM'
  },
  {
    name: 'Canada(1)',
    value: '1',
    code: 'CA'
  },
  {
    name: 'Cape Verde(238)',
    value: '238',
    code: 'CV'
  },
  {
    name: 'Cayman Islands(345)',
    value: '345',
    code: 'KY'
  },
  {
    name: 'Central African Republic(236)',
    value: '236',
    code: 'CF'
  },
  {
    name: 'Chad(235)',
    value: '235',
    code: 'TD'
  },
  {
    name: 'Chile(56)',
    value: '56',
    code: 'CL'
  },
  {
    name: 'China(86)',
    value: '86',
    code: 'CN'
  },
  {
    name: 'Christmas Island(61)',
    value: '61',
    code: 'CX'
  },
  {
    name: 'Cocos (Keeling) Islands(61)',
    value: '61',
    code: 'CC'
  },
  {
    name: 'Colombia(57)',
    value: '57',
    code: 'CO'
  },
  {
    name: 'Comoros(269)',
    value: '269',
    code: 'KM'
  },
  {
    name: 'Congo(242)',
    value: '242',
    code: 'CG'
  },
  {
    name: 'Congo, The Democratic Republic of the Congo(243)',
    value: '243',
    code: 'CD'
  },
  {
    name: 'Cook Islands(682)',
    value: '682',
    code: 'CK'
  },
  {
    name: 'Costa Rica(506)',
    value: '506',
    code: 'CR'
  },
  {
    name: "Cote d'Ivoire(225)",
    value: '225',
    code: 'CI'
  },
  {
    name: 'Croatia(385)',
    value: '385',
    code: 'HR'
  },
  {
    name: 'Cuba(53)',
    value: '53',
    code: 'CU'
  },
  {
    name: 'Cyprus(357)',
    value: '357',
    code: 'CY'
  },
  {
    name: 'Czech Republic(420)',
    value: '420',
    code: 'CZ'
  },
  {
    name: 'Denmark(45)',
    value: '45',
    code: 'DK'
  },
  {
    name: 'Djibouti(253)',
    value: '253',
    code: 'DJ'
  },
  {
    name: 'Dominica(1767)',
    value: '1767',
    code: 'DM'
  },
  {
    name: 'Dominican Republic(1849)',
    value: '1849',
    code: 'DO'
  },
  {
    name: 'Ecuador(593)',
    value: '593',
    code: 'EC'
  },
  {
    name: 'Egypt(20)',
    value: '20',
    code: 'EG'
  },
  {
    name: 'El Salvador(503)',
    value: '503',
    code: 'SV'
  },
  {
    name: 'Equatorial Guinea(240)',
    value: '240',
    code: 'GQ'
  },
  {
    name: 'Eritrea(291)',
    value: '291',
    code: 'ER'
  },
  {
    name: 'Estonia(372)',
    value: '372',
    code: 'EE'
  },
  {
    name: 'Ethiopia(251)',
    value: '251',
    code: 'ET'
  },
  {
    name: 'Falkland Islands (Malvinas)(500)',
    value: '500',
    code: 'FK'
  },
  {
    name: 'Faroe Islands(298)',
    value: '298',
    code: 'FO'
  },
  {
    name: 'Fiji(679)',
    value: '679',
    code: 'FJ'
  },
  {
    name: 'Finland(358)',
    value: '358',
    code: 'FI'
  },

  {
    name: 'French Guiana(594)',
    value: '594',
    code: 'GF'
  },
  {
    name: 'French Polynesia(689)',
    value: '689',
    code: 'PF'
  },
  {
    name: 'Gabon(241)',
    value: '241',
    code: 'GA'
  },
  {
    name: 'Gambia(220)',
    value: '220',
    code: 'GM'
  },
  {
    name: 'Georgia(995)',
    value: '995',
    code: 'GE'
  },
  {
    name: 'Germany(49)',
    value: '49',
    code: 'DE'
  },
  {
    name: 'Ghana(233)',
    value: '233',
    code: 'GH'
  },
  {
    name: 'Gibraltar(350)',
    value: '350',
    code: 'GI'
  },
  {
    name: 'Greece(30)',
    value: '30',
    code: 'GR'
  },
  {
    name: 'Greenland(299)',
    value: '299',
    code: 'GL'
  },
  {
    name: 'Grenada(1473)',
    value: '1473',
    code: 'GD'
  },
  {
    name: 'Guadeloupe(590)',
    value: '590',
    code: 'GP'
  },
  {
    name: 'Guam(1671)',
    value: '1671',
    code: 'GU'
  },
  {
    name: 'Guatemala(502)',
    value: '502',
    code: 'GT'
  },
  {
    name: 'United Kingdom(44)',
    value: '44',
    code: 'UK'
  },
  {
    name: 'Guinea(224)',
    value: '224',
    code: 'GN'
  },
  {
    name: 'Guinea-Bissau(245)',
    value: '245',
    code: 'GW'
  },
  {
    name: 'Guyana(595)',
    value: '595',
    code: 'GY'
  },
  {
    name: 'Haiti(509)',
    value: '509',
    code: 'HT'
  },
  {
    name: 'Holy See (Vatican City State)(379)',
    value: '379',
    code: 'VA'
  },
  {
    name: 'Honduras(504)',
    value: '504',
    code: 'HN'
  },

  {
    name: 'Hungary(36)',
    value: '36',
    code: 'HU'
  },
  {
    name: 'Iceland(354)',
    value: '354',
    code: 'IS'
  },
  {
    name: 'India(91)',
    value: '91',
    code: 'IN'
  },
  {
    name: 'Indonesia(62)',
    value: '62',
    code: 'ID'
  },
  {
    name: 'Iran, Islamic Republic of Persian Gulf(98)',
    value: '98',
    code: 'IR'
  },
  {
    name: 'Iraq(964)',
    value: '964',
    code: 'IQ'
  },
  {
    name: 'Ireland(353)',
    value: '353',
    code: 'IE'
  },
  {
    name: 'Isle of Man(44)',
    value: '44',
    code: 'IM'
  },
  {
    name: 'Israel(972)',
    value: '972',
    code: 'IL'
  },
  {
    name: 'Italy(39)',
    value: '39',
    code: 'IT'
  },
  {
    name: 'Jamaica(1876)',
    value: '1876',
    code: 'JM'
  },

  {
    name: 'Jersey(44)',
    value: '44',
    code: 'JE'
  },
  {
    name: 'Jordan(962)',
    value: '962',
    code: 'JO'
  },
  {
    name: 'Kazakhstan(7)',
    value: '7',
    code: 'KZ'
  },
  {
    name: 'Kenya(254)',
    value: '254',
    code: 'KE'
  },
  {
    name: 'Kiribati(686)',
    value: '686',
    code: 'KI'
  },

  {
    name: 'Korea, Republic of South Korea(82)',
    value: '82',
    code: 'KR'
  },
  {
    name: 'Kuwait(965)',
    value: '965',
    code: 'KW'
  },
  {
    name: 'Kyrgyzstan(996)',
    value: '996',
    code: 'KG'
  },
  {
    name: 'Laos(856)',
    value: '856',
    code: 'LA'
  },
  {
    name: 'Latvia(371)',
    value: '371',
    code: 'LV'
  },
  {
    name: 'Lebanon(961)',
    value: '961',
    code: 'LB'
  },
  {
    name: 'Lesotho(266)',
    value: '266',
    code: 'LS'
  },
  {
    name: 'Liberia(231)',
    value: '231',
    code: 'LR'
  },
  {
    name: 'Libyan Arab Jamahiriya(218)',
    value: '218',
    code: 'LY'
  },
  {
    name: 'Liechtenstein(423)',
    value: '423',
    code: 'LI'
  },
  {
    name: 'Lithuania(370)',
    value: '370',
    code: 'LT'
  },
  {
    name: 'Luxembourg(352)',
    value: '352',
    code: 'LU'
  },
  {
    name: 'Macao(853)',
    value: '853',
    code: 'MO'
  },
  {
    name: 'Macedonia(389)',
    value: '389',
    code: 'MK'
  },
  {
    name: 'Madagascar(261)',
    value: '261',
    code: 'MG'
  },
  {
    name: 'Malawi(265)',
    value: '265',
    code: 'MW'
  },

  {
    name: 'Maldives(960)',
    value: '960',
    code: 'MV'
  },
  {
    name: 'Mali(223)',
    value: '223',
    code: 'ML'
  },
  {
    name: 'Malta(356)',
    value: '356',
    code: 'MT'
  },
  {
    name: 'Marshall Islands(692)',
    value: '692',
    code: 'MH'
  },
  {
    name: 'Martinique(596)',
    value: '596',
    code: 'MQ'
  },
  {
    name: 'Mauritania(222)',
    value: '222',
    code: 'MR'
  },
  {
    name: 'Mauritius(230)',
    value: '230',
    code: 'MU'
  },
  {
    name: 'Mayotte(262)',
    value: '262',
    code: 'YT'
  },
  {
    name: 'Mexico(52)',
    value: '52',
    code: 'MX'
  },
  {
    name: 'Micronesia, Federated States of Micronesia(691)',
    value: '691',
    code: 'FM'
  },
  {
    name: 'Moldova(373)',
    value: '373',
    code: 'MD'
  },
  {
    name: 'Monaco(377)',
    value: '377',
    code: 'MC'
  },
  {
    name: 'Mongolia(976)',
    value: '976',
    code: 'MN'
  },
  {
    name: 'Montenegro(382)',
    value: '382',
    code: 'ME'
  },
  {
    name: 'Montserrat(1664)',
    value: '1664',
    code: 'MS'
  },
  {
    name: 'Morocco(212)',
    value: '212',
    code: 'MA'
  },
  {
    name: 'Mozambique(258)',
    value: '258',
    code: 'MZ'
  },
  {
    name: 'Myanmar(95)',
    value: '95',
    code: 'MM'
  },
  {
    name: 'Namibia(264)',
    value: '264',
    code: 'NA'
  },
  {
    name: 'Nauru(674)',
    value: '674',
    code: 'NR'
  },
  {
    name: 'Nepal(977)',
    value: '977',
    code: 'NP'
  },
  {
    name: 'Netherlands(31)',
    value: '31',
    code: 'NL'
  },
  {
    name: 'Netherlands Antilles(599)',
    value: '599',
    code: 'AN'
  },
  {
    name: 'New Caledonia(687)',
    value: '687',
    code: 'NC'
  },
  {
    name: 'New Zealand(64)',
    value: '64',
    code: 'NZ'
  },
  {
    name: 'Nicaragua(505)',
    value: '505',
    code: 'NI'
  },
  {
    name: 'Niger(227)',
    value: '227',
    code: 'NE'
  },
  {
    name: 'Nigeria(234)',
    value: '234',
    code: 'NG'
  },
  {
    name: 'Niue(683)',
    value: '683',
    code: 'NU'
  },
  {
    name: 'Norfolk Island(672)',
    value: '672',
    code: 'NF'
  },
  {
    name: 'Northern Mariana Islands(1670)',
    value: '1670',
    code: 'MP'
  },
  {
    name: 'Norway(47)',
    value: '47',
    code: 'NO'
  },
  {
    name: 'Oman(968)',
    value: '968',
    code: 'OM'
  },
  {
    name: 'Pakistan(92)',
    value: '92',
    code: 'PK'
  },
  {
    name: 'Palau(680)',
    value: '680',
    code: 'PW'
  },
  {
    name: 'Palestinian Territory, Occupied(970)',
    value: '970',
    code: 'PS'
  },
  {
    name: 'Panama(507)',
    value: '507',
    code: 'PA'
  },
  {
    name: 'Papua New Guinea(675)',
    value: '675',
    code: 'PG'
  },
  {
    name: 'Paraguay(595)',
    value: '595',
    code: 'PY'
  },
  {
    name: 'Peru(51)',
    value: '51',
    code: 'PE'
  },
  {
    name: 'Philippines(63)',
    value: '63',
    code: 'PH'
  },
  {
    name: 'Pitcairn(872)',
    value: '872',
    code: 'PN'
  },
  {
    name: 'Poland(48)',
    value: '48',
    code: 'PL'
  },
  {
    name: 'Portugal(351)',
    value: '351',
    code: 'PT'
  },
  {
    name: 'Puerto Rico(1939)',
    value: '1939',
    code: 'PR'
  },
  {
    name: 'Qatar(974)',
    value: '974',
    code: 'QA'
  },
  {
    name: 'Romania(40)',
    value: '40',
    code: 'RO'
  },
  {
    name: 'Russia(7)',
    value: '7',
    code: 'RU'
  },
  {
    name: 'Rwanda(250)',
    value: '250',
    code: 'RW'
  },
  {
    name: 'Reunion(262)',
    value: '262',
    code: 'RE'
  },
  {
    name: 'Saint Barthelemy(590)',
    value: '590',
    code: 'BL'
  },
  {
    name: 'Saint Helena, Ascension and Tristan Da Cunha(290)',
    value: '290',
    code: 'SH'
  },
  {
    name: 'Saint Kitts and Nevis(1869)',
    value: '1869',
    code: 'KN'
  },
  {
    name: 'Saint Lucia(1758)',
    value: '1758',
    code: 'LC'
  },
  {
    name: 'Saint Martin(590)',
    value: '590',
    code: 'MF'
  },
  {
    name: 'Saint Pierre and Miquelon(508)',
    value: '508',
    code: 'PM'
  },
  {
    name: 'Saint Vincent and the Grenadines(1784)',
    value: '1784',
    code: 'VC'
  },
  {
    name: 'Samoa(685)',
    value: '685',
    code: 'WS'
  },
  {
    name: 'San Marino(378)',
    value: '378',
    code: 'SM'
  },
  {
    name: 'Sao Tome and Principe(239)',
    value: '239',
    code: 'ST'
  },
  {
    name: 'Saudi Arabia(966)',
    value: '966',
    code: 'SA'
  },
  {
    name: 'Senegal(221)',
    value: '221',
    code: 'SN'
  },
  {
    name: 'Serbia(381)',
    value: '381',
    code: 'RS'
  },
  {
    name: 'Seychelles(248)',
    value: '248',
    code: 'SC'
  },
  {
    name: 'Sierra Leone(232)',
    value: '232',
    code: 'SL'
  },

  {
    name: 'Slovakia(421)',
    value: '421',
    code: 'SK'
  },
  {
    name: 'Slovenia(386)',
    value: '386',
    code: 'SI'
  },
  {
    name: 'Solomon Islands(677)',
    value: '677',
    code: 'SB'
  },
  {
    name: 'Somalia(252)',
    value: '252',
    code: 'SO'
  },
  {
    name: 'South Africa(27)',
    value: '27',
    code: 'ZA'
  },
  {
    name: 'South Sudan(211)',
    value: '211',
    code: 'SS'
  },
  {
    name: 'South Georgia and the South Sandwich Islands(500)',
    value: '500',
    code: 'GS'
  },
  {
    name: 'Spain(34)',
    value: '34',
    code: 'ES'
  },
  {
    name: 'Sri Lanka(94)',
    value: '94',
    code: 'LK'
  },
  {
    name: 'Sudan(249)',
    value: '249',
    code: 'SD'
  },
  {
    name: 'Suriname(597)',
    value: '597',
    code: 'SR'
  },
  {
    name: 'Svalbard and Jan Mayen(47)',
    value: '47',
    code: 'SJ'
  },
  {
    name: 'Swaziland(268)',
    value: '268',
    code: 'SZ'
  },
  {
    name: 'Sweden(46)',
    value: '46',
    code: 'SE'
  },
  {
    name: 'Switzerland(41)',
    value: '41',
    code: 'CH'
  },
  {
    name: 'Syrian Arab Republic(963)',
    value: '963',
    code: 'SY'
  },

  {
    name: 'Tajikistan(992)',
    value: '992',
    code: 'TJ'
  },
  {
    name: 'Tanzania, United Republic of Tanzania(255)',
    value: '255',
    code: 'TZ'
  },

  {
    name: 'Timor-Leste(670)',
    value: '670',
    code: 'TL'
  },
  {
    name: 'Togo(228)',
    value: '228',
    code: 'TG'
  },
  {
    name: 'Tokelau(690)',
    value: '690',
    code: 'TK'
  },
  {
    name: 'Tonga(676)',
    value: '676',
    code: 'TO'
  },
  {
    name: 'Trinidad and Tobago(1868)',
    value: '1868',
    code: 'TT'
  },
  {
    name: 'Tunisia(216)',
    value: '216',
    code: 'TN'
  },
  {
    name: 'Turkey(90)',
    value: '90',
    code: 'TR'
  },
  {
    name: 'Turkmenistan(993)',
    value: '993',
    code: 'TM'
  },
  {
    name: 'Turks and Caicos Islands(1649)',
    value: '1649',
    code: 'TC'
  },
  {
    name: 'Tuvalu(688)',
    value: '688',
    code: 'TV'
  },
  {
    name: 'Uganda(256)',
    value: '256',
    code: 'UG'
  },
  {
    name: 'Ukraine(380)',
    value: '380',
    code: 'UA'
  },
  {
    name: 'United Arab Emirates(971)',
    value: '971',
    code: 'AE'
  },
  {
    name: 'United Kingdom(44)',
    value: '44',
    code: 'GB'
  },
  {
    name: 'United States(1)',
    value: '1',
    code: 'US'
  },
  {
    name: 'Uruguay(598)',
    value: '598',
    code: 'UY'
  },
  {
    name: 'Uzbekistan(998)',
    value: '998',
    code: 'UZ'
  },
  {
    name: 'Vanuatu(678)',
    value: '678',
    code: 'VU'
  },
  {
    name: 'Venezuela, Bolivarian Republic of Venezuela(58)',
    value: '58',
    code: 'VE'
  },

  {
    name: 'Virgin Islands, British(1284)',
    value: '1284',
    code: 'VG'
  },
  {
    name: 'Virgin Islands, U.S.(1340)',
    value: '1340',
    code: 'VI'
  },
  {
    name: 'Wallis and Futuna(681)',
    value: '681',
    code: 'WF'
  },
  {
    name: 'Yemen(967)',
    value: '967',
    code: 'YE'
  },
  {
    name: 'Zambia(260)',
    value: '260',
    code: 'ZM'
  },
  {
    name: 'Zimbabwe(263)',
    value: '263',
    code: 'ZW'
  }
]

export default code
